export const delay = (time: number) =>
  new Promise((response) => setTimeout(response, time));
